import { useEffect, useState } from 'react';

import AdminLayout from '../../Layouts/AdminLayout';

import BlockContent from '../../Components/Manager/BlockContent';
import { useNotification } from '../../Contexts/NotificationContext';

function App() {
    const { setNotification } = useNotification();
    const [types, setTypes] = useState([]);
    const [downloads, setDownloads] = useState([]);
    const [loading, setLoading] = useState(true);

    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    const fetchContent = async () => {
        try {
            const response = await fetch(`${baseUrl}/manager/downloads/tipos`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
            });

            if (response.ok) {
                const downloadsData = await response.json();
                setTypes(downloadsData.tipos_downloads || []);
                setDownloads(downloadsData.downloads || []);
            } else {
                throw new Error('Erro ao buscar os produtos.');
            }
        } catch (error) {
            setNotification({
                type: 'error',
                message: error.message,
                show: true,
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchContent();
    }, []);

    const contentTypes = {
        nome: ['Tipos', 'tipo'],
        route: 'downloads/tipos',
        imagens: false,
        editavel: true,
        conteudo: types,
        onUpdate: fetchContent,
    };

    const contentDownloads = {
        nome: ['Downloads', 'download'],
        route: 'downloads/arquivos',
        imagens: false,
        editavel: true,
        conteudo: downloads,
        onUpdate: fetchContent,
    };

    return (
        <AdminLayout>
            <div className="mx-auto max-w-screen-2xl p-4 md:p-6 2xl:p-10">
                <div className="mt-4 grid grid-cols-12 gap-4 md:mt-4 md:gap-6 2xl:mt-7.5 2xl:gap-7.5">
                    <div className="col-span-12">
                        <BlockContent content={contentTypes} loading={loading} />

                        <BlockContent content={contentDownloads} loading={loading} id={1} />
                    </div>
                </div>
            </div>
        </AdminLayout>
    );
}

export default App;
